import LabelsConfig from '../../settings/LabelsConfig';
import resolveAdressLabels, { REPLAN_LABEL_KEY } from '../../../helpers/adressHelpers/resolveAdressLabels';

/**
 * Instellingen → Ondersteuning → 'Labels bij huishoudens': de labels die een
 * organisatie op een huishouden kan zetten. Twee zijn ingebouwd ('Opnieuw
 * inplannen' en 'Extra aandacht'); 'Opnieuw inplannen' stuurt de lijst
 * 'Inplannen' en is daarom niet te verbergen.
 * AI-CONTEXT: See docs/features/planner-overzicht-bkb.md
 *
 * @returns {JSX.Element}
 */
const AdressLabelsConfig = () => (
    <LabelsConfig
        field="AdressLabels"
        heading="Labels bij huishoudens"
        intro={"Labels zet je op een huishouden naast de status, meerdere tegelijk, in de kolom 'LABELS' van het overzicht. 'Opnieuw inplannen' zet een huishouden in de lijst 'Inplannen' en gaat vanzelf weg zodra er een afspraak staat; die is daarom niet te verbergen."}
        resolve={resolveAdressLabels}
        fixedKey={REPLAN_LABEL_KEY}
    />
);

export default AdressLabelsConfig;
